export interface SerpTrackingKeywordRankGq {
  domainId: number;
  rank?: number;
  url: string;
  projectRequestId: number;
}

export const SerpTrackingKeywordRankGqProps = `
  domainId
  rank
  url
  projectRequestId
`;
